'use es6';

import http from 'hub-http/clients/apiClient';
import { byName as TemplateTypes } from 'ContentUtils/constants/TemplateTypes';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
import { formatPathSlug } from '../lib/path';
const BASE_API_PATH = 'designmanager/v1/templates';
/**
 * POST designmanager/v1/templates
 */

export function create(data) {
  return http.post(BASE_API_PATH, {
    data
  });
}
/**
 * GET designmanager/v1/templates/:templateId
 */

export function fetch(templateId) {
  return http.get(`${BASE_API_PATH}/${templateId}`);
}
/**
 * PUT designmanager/v1/templates/:templateId
 */

export function save(templateId, data) {
  return http.put(`${BASE_API_PATH}/${templateId}`, {
    data
  });
}
/**
 * DELETE designmanager/v1/templates/:templateId
 */

export function del(templateId) {
  return http.delete(`${BASE_API_PATH}/${templateId}`);
}
/**
 * DELETE designmanager/v1/templates/bulk?id=1&id=2
 */

export function bulkDelete(templateIds) {
  return http.delete(`${BASE_API_PATH}/bulk`, {
    query: {
      id: templateIds
    }
  });
}
/**
 * POST designmanager/v1/templates/:templateId/clone
 */

export function clone(templateId, data) {
  return http.post(`${BASE_API_PATH}/${templateId}/clone`, {
    data
  });
}
/**
 * PUT designmanager/v1/templates/:templateId/restore-deleted
 */

export function restoreDeleted(templateId) {
  return http.put(`${BASE_API_PATH}/${templateId}/restore-deleted`);
}

function createFetchByTemplateType(templateType) {
  const query = {
    templateType,
    limit: 2750,
    property: ['id', 'label', 'path']
  };
  return () => {
    return http.get(BASE_API_PATH, {
      query
    });
  };
}
/**
 * GET designmanager/v1/templates?templateType=24
 */


export const fetchStylesheets = createFetchByTemplateType(TemplateTypes.css.id);
/**
 * GET designmanager/v1/templates?templateType=25
 */

export const fetchJavascripts = createFetchByTemplateType(TemplateTypes.js.id);
/**
 * POST designmanager/v1/validate-email-v3-rendering
 */

export function validateEmailTemplateVersionChange(templateBuffer) {
  return http.post(`${BASE_API_PATH}/validate-email-v3-rendering`, {
    data: templateBuffer
  });
}
/*
 * POST /designmanager/v1/templates/by-path/p:path
 */

export function createByPath(path, template) {
  return http.post(`${BASE_API_PATH}/by-path/${formatPathSlug(path)}`, {
    data: template,
    query: {
      environmentId: STAGED
    }
  });
}
/**
 * POST designmanager/v1/templates/clone/by-path/:path
 */

export function cloneByPath(path, data) {
  return http.post(`${BASE_API_PATH}/clone/by-path/${encodeURIComponent(path)}`, {
    data,
    query: {
      environmentId: STAGED
    }
  });
}
/**
 * PUT /designmanager/v1/templates/by-path/p:path
 */

export function saveByPath(templatePath, template) {
  return http.put(`${BASE_API_PATH}/by-path/${formatPathSlug(templatePath)}`, {
    data: template,
    query: {
      environmentId: STAGED
    }
  });
}
/**
 * GET /designmanager/v1/templates?deployId=1&path=project%2path
 */

export function fetchTemplateByBuild(deployId, templatePath) {
  const path = encodeURIComponent(templatePath);
  return http.get(`${BASE_API_PATH}?deployId=${deployId}&path=${path}`);
}